import { FC } from "react";
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	Stack,
	ToggleButton,
	ToggleButtonGroup,
} from "@mui/material";
import {
	EventRatingsEnrollment,
	EventRatingsEvent,
} from "../../../../../services/reports.service";

export type ViewMode = "population" | "single";

interface EventRatingsSelectorBarProps {
	idPrefix: string;
	events: EventRatingsEvent[];
	enrollments: EventRatingsEnrollment[];
	eventId: string;
	viewMode: ViewMode;
	enrollmentId: string;
	onChange: (next: {
		eventId?: string;
		viewMode?: ViewMode;
		enrollmentId?: string;
	}) => void;
}

const EventRatingsSelectorBar: FC<EventRatingsSelectorBarProps> = ({
	idPrefix,
	events,
	enrollments,
	eventId,
	viewMode,
	enrollmentId,
	onChange,
}) => {
	return (
		<Stack
			direction={{ xs: "column", md: "row" }}
			spacing={2}
			alignItems={{ xs: "stretch", md: "center" }}
		>
			<FormControl size="small" sx={{ minWidth: 220 }}>
				<InputLabel id={`${idPrefix}-event-label`}>Event</InputLabel>
				<Select
					labelId={`${idPrefix}-event-label`}
					label="Event"
					value={eventId}
					onChange={(e) => onChange({ eventId: e.target.value })}
					disabled={events.length === 0}
				>
					{events.map((ev) => (
						<MenuItem key={ev.eventId} value={ev.eventId}>
							{ev.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>

			<ToggleButtonGroup
				size="small"
				exclusive
				value={viewMode}
				onChange={(_e, next: ViewMode | null) => {
					if (next) onChange({ viewMode: next });
				}}
				aria-label="View mode"
			>
				<ToggleButton value="population" aria-label="Population average">
					Population
				</ToggleButton>
				<ToggleButton value="single" aria-label="Single enrollment">
					Single enrollment
				</ToggleButton>
			</ToggleButtonGroup>

			{viewMode === "single" && (
				<FormControl size="small" sx={{ minWidth: 240 }}>
					<InputLabel id={`${idPrefix}-enrollment-label`}>
						Enrollment
					</InputLabel>
					<Select
						labelId={`${idPrefix}-enrollment-label`}
						label="Enrollment"
						value={enrollmentId}
						onChange={(e) => onChange({ enrollmentId: e.target.value })}
						disabled={enrollments.length === 0}
					>
						{enrollments.map((en) => (
							<MenuItem key={en.enrollmentId} value={en.enrollmentId}>
								{en.participantName}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			)}
		</Stack>
	);
};

export default EventRatingsSelectorBar;
